import { graphql } from 'gatsby';
import { Anchor } from '@twilio-paste/anchor';
import { Box } from '@twilio-paste/box';
import { Heading } from '@twilio-paste/heading';
import { UnorderedList, ListItem } from '@twilio-paste/list';
import { Breadcrumb, BreadcrumbItem } from '@twilio-paste/breadcrumb';
import { Table, THead, TBody, Td, Th, Tr } from '@twilio-paste/table';
import { Truncate } from '@twilio-paste/truncate';
import Changelog from '@twilio-paste/breadcrumb/CHANGELOG.md';
import { DoDont, Do, Dont } from "../../../../src/components/DoDont";
import { Callout, CalloutTitle, CalloutText } from "../../../../src/components/callout";
import { SidebarCategoryRoutes } from "../../../../src/constants";
import * as React from 'react';
export default {
  graphql,
  Anchor,
  Box,
  Heading,
  UnorderedList,
  ListItem,
  Breadcrumb,
  BreadcrumbItem,
  Table,
  THead,
  TBody,
  Td,
  Th,
  Tr,
  Truncate,
  Changelog,
  DoDont,
  Do,
  Dont,
  Callout,
  CalloutTitle,
  CalloutText,
  SidebarCategoryRoutes,
  React
};